import { LocalizationService } from './../../services/localization.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AccountInfo } from '../../models/accountInfo.model';
import { AccountState } from '../../ngxs/state/account.state';
import { ChangePasswordModel } from './../../models/change-password.model';
import { ChangePassword } from './../../ngxs/action/account.action';
import { NotificationService } from './../../services/notification.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  formGroup: FormGroup;
  @Select(AccountState.account)
  account$: Observable<AccountInfo>;
  email: string;
  subscription = new Subscription();
  public accountInfo: AccountInfo = new AccountInfo();
  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private localizationService: LocalizationService
  ) {}

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });

    this.subscription.add(
      this.account$.subscribe((x) => {
        if (x) {
          this.email = x.email;
        }
      })
    );
  }

  changePassword() {
    if (this.formGroup.valid) {
      const model = new ChangePasswordModel();
      model.oldPassword = this.formGroup.controls['oldPassword'].value;
      model.newPassword = this.formGroup.controls['newPassword'].value;
      model.confirmPassword = this.formGroup.controls['confirmPassword'].value;
      model.email = this.email;
      // SET email account from logged user
      if (model.newPassword !== model.confirmPassword) {
        this.notificationService.warning(
          this.localizationService.translate('password-match'),
          this.localizationService.translate('passwords-not-match')
        );
      } else {
        this.store.dispatch(new ChangePassword(model));
      }
    }
  }

  get isValid() {
    return this.formGroup.valid;
  }
}
